<template>
  <div>
    <!-- NAVBAR -->
    <my-navbar :controller="controller" />

    <!-- HEADER -->
    <div class="header bg-gradient-dark pb-8 pt-5 pt-md-8">
      <div class="container-fluid">
        <div class="header-body">
          <div class="row">
            <!-- CONTENIDO HEADER -->
            <div class="col-lg-7 col-md-10">
              <h1 class="display-3 text-white">Administración</h1>
              <p class="text-white mt-0 mb-5">Registros agregados a Lista Premium</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- CONTENT -->
    <div class="container-fluid mt--7 bg-secondary">
      <div class="row row-asociations">
        <!-- <my-spinner :loading="loading" /> -->
        <div class="col-lg-3 col-md-4 col-sm-4 col-xs-12">
          <div class="card shadow">
            <div class="card-header">Buscar registros</div>
            <div class="card-body">
              <p
                class="text-muted m-0 text-xs"
              >Comienza tu búsqueda seleccionando Marca, Año y Versión del vehículo.</p>
              <hr class="m-0 my-3" />
              <my-spinner :loading="filters.loading" />
              <div class="form-group mb-3">
                <select
                  class="form-control form-control-alternative"
                  v-model="filters.selected.brand"
                >
                  <option value>Selecciona una marca</option>
                  <option v-for="s in filters.brands" :value="s.value" :key="s.value">{{s.caption}}</option>
                </select>
              </div>

              <div class="form-group mb-3">
                <select
                  class="form-control form-control-alternative"
                  v-model="filters.selected.year"
                >
                  <option value="0">Seleccione el año</option>
                  <option v-for="s in filters.years" :value="s.value" :key="s.value">{{s.caption}}</option>
                </select>
              </div>

              <div class="form-group mb-3">
                <v-select
                  label="caption"
                  :options="filters.models"
                  v-model="filters.selected.model"
                  style="width:100%"
                  placeholder="Selecciona uno o varios modelos"
                  :disabled="loading"
                >
                  <span slot="no-options">No hay resultados disponibles</span>
                </v-select>
              </div>
              <div class="form-group" v-if="tmp.length > 0 && search">
                <button class="btn btn-secondary btn-sm" type="button" @click="resetSearch">LIMPIAR</button>
              </div>
              <div class="row bg-secondary py-3" v-if="tmp.length > 0">
                <div class="col-sm-12">
                  <h4 class="text-muted m-0 mb-2">Filtrar por fecha</h4>
                </div>
                <div class="col-sm-12">
                  <div class="form-group mb-1">
                    <label class="small text-muted" for>Fecha Inicio</label>
                    <input
                      type="date"
                      class="form-control form-control-alternative"
                      v-model="fecha_inicial"
                      :min="lastMonth"
                      :max="now"
                      :disabled="loading"
                    />
                  </div>
                </div>
                <div class="col-sm-12">
                  <div class="form-group mb-1">
                    <label class="small text-muted" for>Fecha Final</label>
                    <input
                      type="date"
                      class="form-control form-control-alternative"
                      v-model="fecha_final"
                      :min="lastMonth"
                      :max="now"
                      :disabled="loading"
                    />
                  </div>
                </div>
                <div class="col-sm-12 text-center">
                  <span
                    class="text-muted text-xs"
                    v-if="invalidDateFormat"
                  >Seleccione un rango válido</span>
                  <span
                    class="text-danger text-xs"
                    v-if="invalidDateRange && !invalidDateFormat"
                  >La Fecha Inicial no debe ser mayor a la Fecha Final</span>
                </div>
                <div class="col-sm-12">
                  <div class="form-group m-0 text-center">
                    <button
                      :disabled="invalidDateFormat || invalidDateRange"
                      @click="dateFilter(false)"
                      class="btn btn-info btn-sm mt-1"
                    >
                      <i class="fa fa-filter"></i> Filtrar por fecha
                    </button>
                  </div>
                </div>
              </div>
              <div
                v-if="error"
                class="alert alert-danger p-2"
              >Ocurrió un error de conexión — Reintenta nuevamente.</div>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-4 col-sm-4 col-xs-12" v-if="!hideResultList">
          <div class="card shadow slide-in-right">
            <div class="card-header text-center">
              Resultados de búsqueda
              <br />
              <small class="text-muted">
                {{filters.selected.brand}}
                <i
                  class="fa fa-angle-double-right text-primary"
                  aria-hidden="true"
                ></i>
                {{filters.selected.model.caption }}
                <i
                  class="fa fa-angle-double-right text-primary"
                  aria-hidden="true"
                ></i>
                {{filters.selected.year }}
              </small>
            </div>
            <div class="card-body bg-secondary p-0">
              <div class="card p-3 small text-center" v-if="filters.loading">
                <i class="fa fa-spin fa-2x fa-circle-o-notch text-primary mb-2"></i> Cargando datos...
              </div>
              <div
                v-if="tmp.length > 0 && !filters.loading && filtrandoPorFecha"
                class="card p-3 text-center"
              >
                <p class="small m-0">Filtrando por fecha</p>
                <button
                  @click="dateFilter(true)"
                  href="javascript:void(0);"
                  class="btn btn-sm btn-info mt-2"
                >Restaurar</button>
              </div>
              <div
                class="card card-stats card-item-rc p-3 small text-center"
                v-if="listado.length == 0 && !filters.loading"
              >No hay resultados</div>
              <div
                v-else
                class="card card-stats"
                v-for="(item, index) in listado"
                :key="item.id+'_rckey'+index"
                @click="selectItem(item)"
                style="cursor:pointer"
              >
                <div class="card-body">
                  <div class="row">
                    <div class="col">
                      <i
                        v-if="post.id_lb == item.id_lb"
                        class="fa fa-chevron-right float-right text-dark mt-3"
                      ></i>
                      <h3 class="card-title text-uppercase mb-0">{{ item.modelo_rc }}</h3>
                      <h6
                        class="card-title text-uppercase mb-0 text-info"
                      >{{item.patentes.length}} patente(s)</h6>
                      <span :class="getStatus(item.estado).class">{{getStatus(item.estado).caption}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-6 col-sm-4 col-xs-12" v-if="post.id_lb > 0">
          <div class="card shadow slide-in-right">
            <my-spinner :loading="loading" />
            <div class="card-header">Detalles</div>
            <div class="card-body">
              <div
                class="alert alert-secondary p-2"
                :class="post.estado == 'APROBADO' ? 'text-info':'text-warning'"
                v-html="post.estado == 'APROBADO' ? 'Registro agregado a <strong>Lista Premium</strong>':'Registro <strong>pendiente</strong> de Aprobación'"
              ></div>
              <div class="row">
                <div class="form-group col-sm-6 mb-2">
                  <label class="text-xs">Marca</label>
                  <input
                    type="text"
                    class="form-control form-control-alternative"
                    placeholder="Ingrese la marca"
                    v-model="post.marca"
                    :disabled="loading"
                  />
                </div>
                <div class="form-group col-sm-6 mb-2">
                  <label class="text-xs">Modelo</label>
                  <input
                    type="text"
                    class="form-control form-control-alternative"
                    placeholder="Ingrese el modelo"
                    v-model="post.modelo"
                    :disabled="loading"
                  />
                </div>
                <div class="form-group col-sm-12 mb-2">
                  <label class="text-xs">Versión</label>
                  <input
                    type="text"
                    class="form-control form-control-alternative"
                    placeholder="Ingrese la versión"
                    v-model="post.version"
                    :disabled="loading"
                  />
                </div>
                <div class="form-group col-sm-6 mb-2">
                  <label class="text-xs">Combustible</label>
                  <select
                    class="form-control form-control-alternative"
                    v-model="post.combustible"
                    :disabled="loading"
                  >
                    <option value="0">Seleccione</option>
                    <option v-for="s in filters.fuels" :value="s.value" :key="s.value">{{s.caption}}</option>
                  </select>
                </div>
                <div class="form-group col-sm-6 mb-2">
                  <label class="text-xs">Puertas</label>
                  <select
                    class="form-control form-control-alternative"
                    v-model="post.puertas"
                    :disabled="loading"
                  >
                    <option v-for="s in filters.doors" :value="s.value" :key="s.value">{{s.caption}}</option>
                  </select>
                </div>
                <div class="form-group col-sm-6 mb-2">
                  <label class="text-xs">Transmisión</label>
                  <select
                    class="form-control form-control-alternative"
                    v-model="post.transmision"
                    :disabled="loading"
                  >
                    <option value>Seleccione</option>
                    <option
                      v-for="s in filters.transmissions"
                      :value="s.value"
                      :key="s.value"
                    >{{s.caption}}</option>
                  </select>
                </div>
                <div class="form-group col-sm-6 mb-2">
                  <label class="text-xs">Carroceria</label>
                  <select
                    class="form-control form-control-alternative"
                    v-model="post.carroceria"
                    :disabled="loading"
                  >
                    <option value>Seleccione</option>
                    <option
                      v-for="s in filters.bodytypes"
                      :value="s.value"
                      :key="s.value"
                    >{{s.caption}}</option>
                  </select>
                </div>
                <div class="col-sm-12 mb-2">
                  <div class="p-2 bg-secondary text-xs p-relative shadow">
                    <i
                      v-b-tooltip.hover
                      title="Información de edición"
                      class="fa fa-info-circle text-info float-right text-xs"
                    ></i>
                    <div>
                      <span class="text-muted">Agregado por</span>
                      {{post.datos_log.usuario_crea}}.
                    </div>
                    <div>
                      <span class="text-muted">Fecha</span>
                      {{post.datos_log.fecha_crea | formatDate}}
                    </div>
                  </div>
                </div>
                <div class="col-sm-12 text-right">
                  <button
                    :disabled="loading"
                    v-if="actions.delete"
                    class="btn btn-link text-danger"
                    @click="rejectItem"
                  >
                    <i class="fa" :class="post.estado == 'APROBADO' ? 'fa-times':'fa-reply'"></i>
                    <span v-text="post.estado == 'APROBADO' ? 'Eliminar':'Rechazar'"></span>
                  </button>
                  <button
                    :disabled="loading"
                    v-if="actions.post || actions.put"
                    class="btn"
                    :class="post.estado == 'APROBADO' ? 'btn-info':'btn-success'"
                    @click="handleApproveItem"
                  >
                    <i class="fa fa-check"></i>
                    <span v-text="post.estado == 'APROBADO' ? 'Actualizar':'Aprobar'"></span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import Auth from "@/helpers/middleware";
import utils from "@/helpers/utils";
import sysMsgs from "@/helpers/system.message";
import RegistroCivilServices from "@/services/registrocivil.services";
import _ from "underscore";
import { post } from "@/views/operaciones/clasificaciones/models/asociacion.model";

let now = moment().format("YYYY-MM-DD");
let lastMonth = moment(
  moment()
    .subtract(2, "months")
    .calendar()
).format("YYYY-MM-DD");

export default {
  name: "AdminListaPremium",
  data() {
    return {
      search: false,
      fecha_inicial: "",
      fecha_final: "",
      actions: Auth.getActions(this.$route.name),
      controller: {
        title: "Operaciones",
        mainRouter: "/operaciones/registro-civil/administracion"
      },
      filtrandoPorFecha: false,
      tmp: [],
      listado: [],
      error: false,
      now: now,
      lastMonth: lastMonth,
      filters: {
        fuels: [],
        transmissions: [
          {
            value: "A",
            caption: "Automática"
          },
          {
            value: "M",
            caption: "Manual"
          }
        ],
        doors: [
          {
            value: 0,
            caption: 0
          },
          {
            value: 1,
            caption: 1
          },
          {
            value: 2,
            caption: 2
          },
          {
            value: 3,
            caption: 3
          },
          {
            value: 4,
            caption: 4
          },
          {
            value: 5,
            caption: 5
          }
        ],
        bodytypes: [],
        brands: [],
        models: [],
        years: [],
        results: [],
        selected: {
          fuel: "",
          transmission: "",
          door: "",
          bodytype: "",
          brand: "",
          model: "",
          year: 0,
          items: [],
          premium: true,
          isNew: false
        },
        loading: true
      },
      post: new post(Auth.getUser().id),
      loading: false,
      messages: {
        danger: "¡Advertencia! Existe más de una versión premium seleccionada",
        warning:
          "¡Advertencia! se actualizarán todos los registros asociados a la lista premium"
      }
    };
  },
  filters: {
    formatDate(val) {
      return utils.formatDateTime(val);
    }
  },
  watch: {
    "filters.selected.brand": {
      handler(data) {
        this.filters.models = [];
        this.filters.years = [];
        this.filters.selected.model = "";
        this.filters.selected.year = 0;
        this.filters.selected.items = [];
        this.post = new post(Auth.getUser().id);
        if (data.trim().length > 0) {
          this.getYears(data);
        }
      }
    },
    "filters.selected.model": {
      handler(data) {
        this.filters.selected.items = [];
        this.post = new post(Auth.getUser().id);

        if (data) {
          this.getInfo(
            this.filters.selected.brand,
            this.filters.selected.year,
            data.value
          );
        }
      }
    },
    "filters.selected.year": {
      handler(data) {
        this.filters.results = [];
        this.filters.selected.items = [];
        this.filters.selected.model = "";
        this.post = new post(Auth.getUser().id);
        if (data && data > 0) {
          this.getModels(this.filters.selected.brand, data);
        }
      }
    },
    "filters.selected.items": {
      handler(data) {
        if (this.filters.results.data) {
          console.log;
          this.unionPatentes(data, true);
        }
      }
    }
  },
  computed: {
    hideResultList() {
      const { brand, model, year } = this.filters.selected;
      return brand == "" || model == null || model == "" || year == 0;
    },
    invalidDateRange() {
      return (
        moment(this.fecha_inicial).format("YYYY-MM-DD") >
        moment(this.fecha_final).format("YYYY-MM-DD")
      );
    },
    invalidDateFormat() {
      return this.fecha_final == "" || this.fecha_inicial == "";
    }
  },
  methods: {
    resetSearch() {
      this.search = false;
      this.filters.models = [];
      this.filters.years = [];
      this.filters.selected.model = "";
      this.filters.selected.brand = "";
      this.filters.selected.year = 0;
      this.filters.selected.items = [];
      this.listado = [];
      this.tmp = [];
      this.post = new post(Auth.getUser().id);
    },
    selectItem(item) {
      this.post = new post(Auth.getUser().id);
      this.post = { ...this.post, ...item };
    },
    dateFilter(param) {
      this.post = new post(Auth.getUser().id);
      this.listado = [...this.tmp]; //Reestablece arreglo de registros original

      if (param) {
        // Restea los rangos de fecha
        this.fecha_inicial = "";
        this.fecha_final = "";
        this.filtrandoPorFecha = false;
        return;
      }

      this.filtrandoPorFecha = true;

      // Aplica filtro con rangos de fecha
      this.listado = [
        ...this.listado.filter(
          item =>
            moment(item.datos_log.fecha_crea).format("YYYY-MM-DD") >=
              moment(this.fecha_inicial).format("YYYY-MM-DD") &&
            moment(item.datos_log.fecha_crea).format("YYYY-MM-DD") <=
              moment(this.fecha_final).format("YYYY-MM-DD")
        )
      ];
    },
    handleApproveItem() {
      const _this = this;
      const action =
        this.post.estado.toString().toLowerCase() == "aprobado"
          ? "ACTUALIZAR"
          : "APROBAR";
      const text = `¿Está seguro que desea ${action} este registro?`;
      sysMsgs.getConfirm(text, "question").then(result => {
        if (result.value) {
          _this.ApproveItem();
        }
      });
    },
    ApproveItem() {
      const {
        patentes,
        usuario,
        id_jato,
        id_lb,
        marca,
        modelo,
        estado,
        version,
        puertas,
        combustible,
        agno,
        carroceria,
        transmision
      } = this.post;

      this.loading = true;

      const _this = this;
      RegistroCivilServices.save
        .setInfo({
          patentes: _.pluck(patentes, "patente"),
          usuario,
          id_jato,
          id_lb,
          marca,
          modelo,
          estado: "APROBADO",
          version,
          puertas,
          combustible,
          agno,
          carroceria,
          transmision
        })
        .then(response => {
          const listado = _this.listado;
          const index = listado.findIndex(
            item => item.id_lb == this.post.id_lb
          );
          listado[index].estado = "APROBADO";
          this.post.estado = "APROBADO";
          _this.listado = [...listado];

          sysMsgs.getMessage("Registro actualizado con éxito", "success");
        })
        .catch(error => {
          console.log("Error", error);
          sysMsgs.getResponseMessage(error.response);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    rejectItem() {
      const _this = this;
      const { usuario, patentes, id_lb } = this.post;

      const action =
        this.post.estado.toString().toLowerCase() == "pendiente"
          ? "RECHAZAR"
          : "ELIMINAR";
      const text = `¿Está seguro que desea ${action} este registro?`;

      this.loading = true;

      sysMsgs.getConfirm(text, "warning").then(result => {
        if (result.value) {
          RegistroCivilServices.save
            .deleteInfo({
              patentes: _.pluck(patentes, "patente"),
              usuario,
              accion: "R"
            })
            .then(response => {
              let listado = _this.listado;
              listado = listado.filter(item => item.id_lb !== this.post.id_lb);

              _this.listado = [...listado];
              _this.tmp = [...listado];

              _this.post = new post(Auth.getUser().id);

              sysMsgs.getMessage("Registro eliminado", "warning");
            })
            .catch(error => {
              console.log("Error", error);
              sysMsgs.getResponseMessage(error.response);
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },
    getFuels() {
      RegistroCivilServices.filters
        .fuels()
        .then(response => {
          this.filters.fuels = _.map(response.data, m => {
            return { caption: m.combustible, value: m.codCombustible };
          });
        })
        .catch(error => {
          sysMsgs.getResponseMessage(error.response);
          this.filters.loading = false;
        });
    },
    getBodyTypes() {
      RegistroCivilServices.filters
        .bodytypes()
        .then(response => {
          this.filters.bodytypes = _.map(response.data, m => {
            return { caption: m.carroceria, value: m.cod_carroceria };
          });
        })
        .catch(error => {
          sysMsgs.getResponseMessage(error.response);
          this.filters.loading = false;
        });
    },
    getStatus(str) {
      switch (str) {
        case "APROBADO":
          return {
            caption: "Lista Premium",
            class: "badge badge-info"
          };
          break;
        case "PENDIENTE":
          return {
            caption: "Por aprobar",
            class: "badge badge-warning"
          };
          break;
        default:
          return { caption: "Pendiente", class: "badge badge-warning" };
          break;
      }
    },
    getBrands() {
      RegistroCivilServices.filters
        .brands()
        .then(response => {
          this.filters.brands = response.data.brands;
          this.filters.loading = false;
        })
        .catch(error => {
          sysMsgs.getResponseMessage(error.response);
          this.filters.loading = false;
        });
    },
    getModels(brand, agno) {
      this.filters.loading = true;
      RegistroCivilServices.filters
        .models(brand, agno)
        .then(response => {
          this.filters.models = response.data.models;
          this.filters.loading = false;
          this.error = false;
        })
        .catch(error => {
          sysMsgs.getResponseMessage(error.response);
          this.filters.loading = false;
          this.error = true;
        });
    },
    getYears(brand) {
      this.filters.loading = true;
      RegistroCivilServices.filters
        .years(brand)
        .then(response => {
          this.filters.years = response.data.years;
          this.filters.loading = false;
          this.error = false;
        })
        .catch(error => {
          sysMsgs.getResponseMessage(error.response);
          this.filters.loading = false;
          this.error = true;
        });
    },
    getInfo(brand, year, model) {
      this.filters.loading = true;
      this.listado = [];
      this.search = true;
      RegistroCivilServices.filters
        .getInfo(brand, year, model)
        .then(response => {
          this.filters.results = response.data;
          this.filters.loading = false;
          this.error = false;

          this.listado = response.data.data.registrocivil.filter(
            item =>
              item.id_lb > 0 &&
              item.asociado &&
              (item.estado == "PENDIENTE" || item.estado == "APROBADO")
          );

          this.tmp = [...this.listado];
        })
        .catch(error => {
          sysMsgs.getResponseMessage(error.response);
          this.filters.loading = false;
          this.error = true;
        })
        .finally(() => {
          this.filtrandoPorFecha = false;
        });
    },
    unionPatentes(data, update) {
      if (this.filters.results.data) {
        let filterArray = _.filter(
          this.filters.results.data.registrocivil,
          filter => _.contains(data, filter.modelo_rc)
        );
        let arrayX = [];
        let mapJato = [];
        mapJato = _.union(arrayX, _.map(filterArray, m => m.id_jato));
        let jato =
          update && mapJato.length <= 1
            ? _.find(this.filters.results.data.jato, find =>
                _.contains(mapJato, find.id_jato)
              )
            : null;
        _.extend(this.post, jato ? jato : new post(Auth.getUser().id));
        this.setPatentes();
      }
    },
    setPatentes() {
      let filterArray = _.filter(
        this.filters.results.data.registrocivil,
        filter => _.contains(this.filters.selected.items, filter.modelo_rc)
      );
      let arrayX = _.union.apply(
        _,
        _.map(_.map(filterArray, a => a.patentes), b =>
          _.map(b, c => c.patente)
        )
      );
      this.post.patentes = arrayX;
    }
  },
  created() {
    this.getFuels();
    this.getBodyTypes();
    this.getBrands();
  }
};
</script>

<style scoped>
.btn-select {
  color: #ddd;
  background-color: #ffffff;
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 5px 10px;
}
.btn-select.active {
  color: #fff;
  background-color: #2dce89;
  border: 1px solid #2dce89;
}
.loading-overlay {
  left: 0;
  top: 0;
}
.text-warning {
  color: #fb6340 !important;
}
</style>
